import { useNotify } from './useNotify'
import { useContext } from './useContext'

export function useOptionOverrideQuery({ onError, onCompleted, context = {}, ...options } = {}) {
  const notify = useNotify()

  const organizationContext = useContext()
  const contextOverride = { ...organizationContext, ...context }

  function onCompletedOverride(data) {
    onCompleted && onCompleted(data, notify)
  }

  function onErrorOverride(error) {
    onError && onError(error, notify)
  }

  return {
    onCompleted: onCompletedOverride,
    onError: onErrorOverride,
    context: contextOverride,
    ...options,
  }
}

export function useOptionOverrideMutation({ onError, onCompleted, context = {}, refetchQueries, ...options } = {}) {
  const notify = useNotify()
  const organizationContext = useContext({ isMutation: true })
  const queryContext = useContext()

  const contextOverride = { ...organizationContext, ...context }

  const refetchQueriesOverride = refetchQueries?.map(({ context: rqContext = {}, ...queryOptions }) => ({
    ...queryOptions,
    context: { ...queryContext, ...context, ...rqContext },
  }))

  function onCompletedOverride(data) {
    onCompleted && onCompleted(data, notify)
  }

  function onErrorOverride(error) {
    if (onError) {
      return onError(error, notify)
    } else {
      // Default error
      return notify.notifyError({ error })
    }
  }

  return {
    onCompleted: onCompletedOverride,
    onError: onErrorOverride,
    context: contextOverride,
    refetchQueries: refetchQueriesOverride,
    ...options,
  }
}
